import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=ea27b550&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"
import style0 from "./brand.vue?vue&type=style&index=0&id=ea27b550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea27b550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea27b550')) {
      api.createRecord('ea27b550', component.options)
    } else {
      api.reload('ea27b550', component.options)
    }
    module.hot.accept("./brand.vue?vue&type=template&id=ea27b550&scoped=true&", function () {
      api.rerender('ea27b550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/brand.vue"
export default component.exports